import { render, staticRenderFns } from "./ReceivingAddressComponent.vue?vue&type=template&id=96fcee08&"
import script from "./ReceivingAddressComponent.vue?vue&type=script&lang=js&"
export * from "./ReceivingAddressComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingAddressComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports